// ── Immagini placeholder reali (per categoria) ────────────────────────────
import tonerImg from '../assets/toner.png';
import toner2Img from '../assets/toner_2.png';
import ricambioImg from '../assets/parti_di_ricambio.png';
import ricambio2Img from '../assets/parti_di_ricambio_2.png';

const CATEGORY_IMAGES: Record<string, [string, string]> = {
  toner: [tonerImg, toner2Img],
};

function getPlaceholderImages(category: string): [string, string] {
  return CATEGORY_IMAGES[category] || [ricambioImg, ricambio2Img];
}

// ── Immagini reali prodotto (Object Storage, vedi Admin > Immagini) ───────
// Popolata una volta all'avvio app da GET /api/products/images-map
// ({sku: url}, URL pubblici del bucket). Nessun call-site deve essere modificato: le funzioni
// getProductThumb/getProductImageMedium/getProductImages qui sotto
// controllano automaticamente questa mappa prima di ricadere sui
// placeholder per-categoria.
let REAL_IMAGE_MAP: Record<string, string> = {};

export async function loadRealProductImages(apiBaseUrl: string): Promise<void> {
  try {
    const res = await fetch(`${apiBaseUrl}/api/products/images-map`);
    if (res.ok) {
      REAL_IMAGE_MAP = await res.json();
    }
  } catch {
    // Silenzioso: in assenza di mappa si ricade sui placeholder categoria.
  }
}

export function getProductImages(sku: string, category: string): string[] {
  const real = REAL_IMAGE_MAP[sku];
  if (real) return [real];
  const [img1, img2] = getPlaceholderImages(category);
  return [img1, img2];
}

/** Ritorna l'URL dell'immagine reale caricata per lo sku, se presente (nessun fallback placeholder). */
export function getRealImage(sku: string): string | undefined {
  return REAL_IMAGE_MAP[sku];
}

export function getProductThumb(sku: string, category: string): string {
  return REAL_IMAGE_MAP[sku] || getPlaceholderImages(category)[0];
}

export function getProductImageMedium(sku: string, category: string): string {
  const real = REAL_IMAGE_MAP[sku];
  if (real) return real;
  const [img1] = getPlaceholderImages(category);
  return img1;
}
